// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.multi-page-search-wrapper {\n    height: auto !important;\n}\n.filtering-ui-wrapper.search-criteria.multi-page-search.fixed-header {\n    position: relative !important;\n}\n", ""]);
// Exports
module.exports = exports;
